import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { ServiceListFragmentDoc } from '../../ServicesList/__generated__/ServicesList.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetServicesEditQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetServicesEditQuery = { __typename?: 'Query', getServiceById?: { __typename?: 'Services', id: string, desc: string, title: string, price: number, category: { __typename?: 'ServicesCategory', id: string, title: string } } | null };


export const GetServicesEditDocument = gql`
    query getServicesEdit($id: ID!) {
  getServiceById(id: $id) {
    ...ServiceList
  }
}
    ${ServiceListFragmentDoc}`;

/**
 * __useGetServicesEditQuery__
 *
 * To run a query within a React component, call `useGetServicesEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServicesEditQuery(baseOptions: Apollo.QueryHookOptions<GetServicesEditQuery, GetServicesEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesEditQuery, GetServicesEditQueryVariables>(GetServicesEditDocument, options);
      }
export function useGetServicesEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesEditQuery, GetServicesEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesEditQuery, GetServicesEditQueryVariables>(GetServicesEditDocument, options);
        }
export type GetServicesEditQueryHookResult = ReturnType<typeof useGetServicesEditQuery>;
export type GetServicesEditLazyQueryHookResult = ReturnType<typeof useGetServicesEditLazyQuery>;
export type GetServicesEditQueryResult = Apollo.QueryResult<GetServicesEditQuery, GetServicesEditQueryVariables>;